import styled from "styled-components";

import {NavBar} from "./components/NavBar/NavBar";
import {AppShell, Container} from "@mantine/core";
import {NavHeader} from "./components/NavHeader/NavHeader";
import {AppContextProvider, ChatProvider, RequireAuth} from "@ots-frontend/ots-ui"
import {FeedbackPrompt} from "@ots-frontend/ots-ui-tw";
import {SpotlightProvider} from "./components/SpotlightProvider/SpotlightProvider";
import {Outlet, useMatch} from "react-router-dom";
import {getAppCategory} from "./store/ui/selectors";
import {setAppCategory} from "./store/ui/actions";
import {baseQueryApi} from "./store/api";
import {TopNavBar} from "./components/TopNavBar/TopNavBar";
import {useNavLayout} from "./hooks/useNavLayout";

const StyledApp = styled.div`
  // Your style here
`;

export const AppOutlet = () => {
  return (
    <AppContextProvider
      getAppCategory={getAppCategory}
      setAppCategory={setAppCategory}
      baseQueryApi={baseQueryApi}
      googleMapsApiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string}
      brand="hub-go"
      density="compact"
      // Follows the scheme stamped on <html>, which the Mantine shell follows too.
      colorScheme="system">
      <App/>
    </AppContextProvider>
  )
}

export function App() {
  const [navLayout] = useNavLayout();
  // The live map runs edge to edge; other pages keep the shell's gutter.
  const fullBleed = useMatch("/map") != null;

  return (
    <RequireAuth>
      <StyledApp>
        <ChatProvider>
          <SpotlightProvider>
            <AppShell
              padding={0}
              // Top navigation carries everything in one bar; side navigation keeps the header and the sidebar.
              header={navLayout === "top" ? <TopNavBar/> : <NavHeader/>}
              navbar={navLayout === "top" ? undefined : <NavBar/>}
            >
              {/* The page scrolls here, under the bar: the scrollbar belongs to the content, not the window. */}
              <div style={{height: "calc(100vh - var(--mantine-header-height, 0px))", overflow: "auto"}}>
                <Container fluid={true} px={fullBleed ? 0 : undefined}>
                  <Outlet/>
                </Container>
              </div>
            </AppShell>
            {/* Signed in only. The top bar carries GoBot itself; the side layout has no room for it, so it floats. */}
            {navLayout !== "top" && <FeedbackPrompt brand="hub-go" colorScheme="system"/>}
          </SpotlightProvider>
        </ChatProvider>
      </StyledApp>
    </RequireAuth>
  );
}
